export const UTM_PARAM_NAME_ALLOWED_CHARS = /[^a-zA-Z0-9._~|-]/g;
export function isUtmNameValid(name) {
    return (name == null || name === name.replace(UTM_PARAM_NAME_ALLOWED_CHARS, ''));
}
//# sourceMappingURL=utm.js.map